import { AppProvider } from '@/providers/app';
import { AppRoutes } from '@/routes/index';
import {
  createBrowserRouter,
  // BrowserRouter as Router,
  RouterProvider,
} from 'react-router-dom';

function App() {
  const router = createBrowserRouter([
    {
      path: '*',
      element: (
        <AppProvider>
          <AppRoutes />
        </AppProvider>
      ),
    },
  ]);

  return (
    // <Router>
    //   <AppProvider>
    //     <AppRoutes />
    //   </AppProvider>
    // </Router>
    <RouterProvider router={router} />
  );
}

export default App;
